import { create } from 'zustand';

const initialState = {
  admin: null,
  athlete: null,
};

const useAppStore = create((set) => ({
  ...initialState,
  reset: () => {
    set(initialState);
  },
  setAdmin: (admin) => set(() => ({ admin, athlete: null })),
  setAthlete: (athlete) => set(() => ({ athlete, admin: null })),
}));

export default useAppStore;
